module.exports = __webpack_public_path__ + "img/content-bg.af3bb0c9.png";